/* eslint-disable camelcase */
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef
} from '@angular/core';
import { NgForm } from '@angular/forms';

import { Subscription } from 'rxjs';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio'; //  ???

import { ReportingService } from '../reporting.service';

import { LoginService } from '../../login/login.service';
import { LoginSettings } from '../../login/LoginSetting.model';

import { Report } from '../models/report.model';
import { ReportParameter } from '../models/report-parameter.model';
import { ParameterRow } from '../models/parameter-row-model';
import { ParameterRows } from '../models/parameter-rows.model';

import { DataSource } from '../models/data-source.model';

import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { UserPreferencesService } from '../../../shared-components/user-preferences/user-preferences.service';

// import { ClassroomSummaryService } from '../../../classroom360/classroom-summary/classroom-summary.service';
// import { StudentService } from '../../../shared-components/student/student.service';
import { ClassroomSummary } from '../../../classroom360/classroom-summary/models/classroom-summary.model';

import { Student } from '../../../shared-components/student/student.model';
import { ReportOptionsComponent } from '../definitions/report-options.component';
import { ReportLegendComponent } from '../report-legend/report-legend.component';
import { ReportSettingsAutoRunComponent } from '../report-settings/report-settings-autorun.component';
import { ConfirmReportToEmailComponent } from './confirm-report-to-email.component';

// import { Form } from '../../../form.model';
import { HasErrors } from '../../../shared-components/guards/check-for-errors/HasErrors';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { StudentSearchComponent } from '../../../shared-components/student-search/student-search.component';
// import moment = require('moment');

import { ArchiveReportModalComponent } from '../archive-report/archive-report-modal.component';



// import { toUnicode } from 'punycode';

@AutoUnsubscribe()
@Component({
  selector: 'reportParameters',
  templateUrl: './report-parameters.component.html',
  styleUrls: ['./report-parameters.component.css']
  // changeDetection: ChangeDetectionStrategy.OnPush
})
// HasErrors

export class ReportParametersComponent implements OnInit, OnDestroy, HasErrors {

  // @Output() showReportToPDF = new EventEmitter<boolean>();
  @ViewChild(ReportSettingsAutoRunComponent)
  private AutoRunComponent: ReportSettingsAutoRunComponent;

  thisDialogRef: MatDialogRef<ReportParametersComponent>;
  reportOptionsDialogRef: MatDialogRef<ReportOptionsComponent>;
  reportLegendDialogRef: MatDialogRef<ReportLegendComponent>;
  confirmReportToEmailDialogRef: MatDialogRef<ConfirmReportToEmailComponent>;
  StudentSearchDialogRef: MatDialogRef<StudentSearchComponent>;
  archiveReportModalDialogRef: MatDialogRef<ArchiveReportModalComponent>;
  loginSettings: LoginSettings;
  utilizeDistributebyEmail: boolean;
  selectedReport: Report;
  userEmail: string;
  isInFolder: boolean;
  showReportToPDF: boolean;
  showCancelSendToEmail: boolean;
  showCancelShowReportOptions: boolean;
  //  cancelShowReport: boolean = false;
  cancelShowReport = false;
  allowAutoRunReport: boolean;
  inDebugMode: boolean;
  MailServer: string;
  maxNumberOfColumns: number;
  ChunkedParameters: ParameterRows;
  subscriptions: Subscription[] = [];
  maxTableCellsPerRow: number;

  // showFooter = true;

  isForSchedule: boolean;
  userPreferences: any;

  selectedCourse: ClassroomSummary;
  selectedStudent: Student;
  selectedStudentSearch: Student;
  studentList = [];
  studentListString: string;
  ParamColWidth: string;
  useReportDefinitions: boolean;
  showHiddenParameters: boolean;
  hiddenParametersLabel: string;
  userHasPrivilegeAddEditDistrictReportDefinitions: boolean;

  showDistributebyEmail: boolean; // ONE-4387

  distributeByEmailOption_StudentSelected: boolean;
  distributeByEmailOption_PrimaryContactSelected: boolean;
  distributeByEmailOption_AllElectronicContactsSelected: boolean;

  utilizeTranscriptTracking: boolean; // ONE-4343
  isTylerAdmin = false;
  debugMessage = '';


  showReportToConsole = false;
  isDebugModeInProduction = false;

  // ERROR HANDLING
  // form: Form;
  errors: ErrorList[] = [];
  // @ViewChild('tableContainer', { read: ElementRef }) tableContainerRef: ElementRef;
  @ViewChild('ngForm', { read: NgForm }) ngForm: NgForm;
  @ViewChild('emailFrom', { read: ElementRef }) emailFrom: ElementRef;
  @ViewChild('emailsToSendReport', { read: ElementRef }) emailsToSendReport: ElementRef;
  @ViewChild('emailSubject', { read: ElementRef }) emailSubject: ElementRef;
  // @ViewChild('DebugInfo', { read: ElementRef }) debugInfo: ElementRef;

  // numbers: number[] = [];
  selectedPostHsInstitution = '';
  PostHsInstitutions: DataSource[];

  constructor(

    reportParametersDialogRef: MatDialogRef<ReportParametersComponent>,
    private studentSearchDialog: MatDialog,
    private reportLegendDialog: MatDialog,
    private confirmReportToEmailDialog: MatDialog,
    private reportOptionsDialog: MatDialog,

    private reportService: ReportingService,
    private loginService: LoginService,
    private userPreferencesService: UserPreferencesService,

    private thisDialog: MatDialog,
    private archiveReportModalDialog: MatDialog,
    // private classroomSummaryService: ClassroomSummaryService,
    // private studentService: StudentService,
    // @Inject(MAT_DIALOG_DATA) public data: any

    // private changeDetector: ChangeDetectorRef
  ) {


    // for (let index = 0; index < 10000; index++) {
    //   this.numbers.push(index);
    // }

    this.userPreferences = this.userPreferencesService;
    this.MailServer = this.loginService.LoginSettings.MailServer;

    /* BEGIN CONSTRUCTOR */
    // this.loginSettings = loginService.LoginSettings;
    // this.utilizeDistributebyEmail = this.loginSettings.UtilizeDistributebyEmail;
    // this.selectedReport = this.reportService.SelectedReport;

    // this.userEmail = this.reportService.userEmail;
    // this.inDebugMode = this.inDebugMode;

    // this.isForSchedule = this.reportService.isForSchedule;

    // this.allowAutoRunReport = this.loginSettings.AllowAutoRunReport;
    // this.showReportToPDF = true;
    // this.showCancelSendToEmail = false;
    // this.showCancelShowReportOptions = false;



    this.thisDialogRef = reportParametersDialogRef;





    // this.getReportDefinitions();

    //  if (this.inDebugMode) {
    //      console.log('ReportParametersComponent => constructor() - selectedReport BELOW');
    //      console.log(this.selectedReport);
    //  }

  } //  end constructor

  // ngOnInit() {

  //   // this.showReportToPDF.emit(true);

  //   //  we need to select all ddcbl items if none are selected
  //   // this.checkAllCheckBoxes();

  // } //  end ngOnInit

  //  Event Functions
  ngOnInit() {
    this.isTylerAdmin = this.reportService.isTylerAdmin;

    // this.loginSettings = this.loginService.LoginSettings;
    // this.utilizeDistributebyEmail = this.loginSettings.UtilizeDistributebyEmail;
    this.selectedReport = this.reportService.SelectedReport;


    this.loginSettings = this.loginService.LoginSettings;

    this.selectedReport.Login_ID = this.loginSettings.Id;
    this.utilizeDistributebyEmail = this.loginSettings.UtilizeDistributebyEmail;
    // this.selectedReport = this.reportService.SelectedReport;
    this.inDebugMode = this.reportService.inDebugMode;
    if (this.inDebugMode || (this.reportService.isTylerAdmin && this.isDebugModeInProduction)) {
      this.showReportToConsole = true;
    }

    this.isForSchedule = this.reportService.isForSchedule;

    this.allowAutoRunReport = this.loginSettings.AllowAutoRunReport;
    this.showReportToPDF = true;
    this.showCancelSendToEmail = false;
    this.showCancelShowReportOptions = false;
    this.showHiddenParameters = false;
    this.hiddenParametersLabel = 'Show Hidden Parameters';

    if (!this.isForSchedule) {
      this.userEmail = this.reportService.userEmail;
      // this.selectedCourse = this.classroomSummaryService.selectedCourse;
      // this.selectedStudent = this.studentService.selectedStudent;
      this.selectedCourse = this.reportService.selectedCourse;
      this.selectedStudent = this.reportService.selectedStudent;
      this.useReportDefinitions = this.reportService.useReportDefinitions;
      this.userHasPrivilegeAddEditDistrictReportDefinitions = this.reportService.userHasPrivilegeAddEditDistrictReportDefinitions;
      this.selectedReport.AutoRunReport = false;
    }

    if (this.selectedReport.ReportFolder == '') {
      this.isInFolder = false;
    } else {
      this.isInFolder = true;
    }

    this.utilizeTranscriptTracking = this.loginService.LoginSettings.UtilizeTranscriptTracking;

    // const transcriptTrackingParam = this.selectedReport.Parameters.find((param) => {
    //   return param.ControlType == 'trctrl';
    // });

    // if (transcriptTrackingParam) {
    //   if (this.reportService.inDebugMode) {
    //     console.log(transcriptTrackingParam);
    //   }
    // }

    // if (this.reportService.inDebugMode) {
    //   this.reportService.utilizeDistributebyEmail = true; // SET FOR TESTING PURPOSES
    //   // console.log(this.MailServer);
    //   // console.log(this.reportService.utilizeDistributebyEmail);
    //   // console.log(this.selectedReport.HasDistributeByEmailParameter);
    //   // console.log(this.selectedReport.HasUniqueStudentParameter);
    // }

    this.reportService.isDistributebyEmail = false;
    this.selectedReport.IsDistributeByEmail = false;

    if (this.MailServer > '' && this.reportService.utilizeDistributebyEmail && this.selectedReport.HasDistributeByEmailParameter && this.selectedReport.HasUniqueStudentParameter) {
      // NOTE: THIS CAN STILL BLOW UP IF THE RESULTS DO NOT HAVE Student_ID IN THE RESULTS!!!!
      this.showDistributebyEmail = true;
    }


    if (!this.isForSchedule) {
      this.selectedReport.EmailFrom = this.userPreferences.generalPreferences.EmailFrom == 'Personal' ? this.userEmail : this.loginSettings.DefaultEmailReplyToAddress;
      this.selectedReport.EmailsToSendReport = this.userEmail;
      this.selectedReport.EmailSubject = this.selectedReport.Name;
      this.selectedReport.EmailBody = 'Please see the attached PDF for this report.';
    }

    this.initParameters();

  }

  ngOnDestroy() {

    // do any necessary cleanup

  }


  initParameters() {
    if (this.reportService.inDebugMode) {
      console.log('here');
    }

    // set params when coming from certain areas

    this.setBackgroundColorForSavedDefinitions();

    if (this.reportService.isAllReports || this.reportService.isMyReports) {
      this.maxTableCellsPerRow = 3;
    }
    else {
      this.maxTableCellsPerRow = 2; // report settings and definitions?
    }
    this.maxNumberOfColumns = this.maxTableCellsPerRow;

    this.setParameterRows(this.maxTableCellsPerRow);


    if (this.maxNumberOfColumns == 1) {
      this.ParamColWidth = '400px';
    }
    else if (this.maxNumberOfColumns == 2) {
      this.ParamColWidth = '350px';
    }
    else if (this.maxNumberOfColumns == 3) {
      this.ParamColWidth = '400px';
    }
    else {
      this.ParamColWidth = '200px';
    }

  }



  setBackgroundColorForSavedDefinitions() {
    if (!this.useReportDefinitions) {
      return; // drop out here
    }
    for (let i = 0; i < this.selectedReport.Parameters.length; i++) {

      if (this.selectedReport.Parameters[i].ParameterReportDefinition.HasParameterValueDefined
        && this.selectedReport.Parameters[i].ParameterReportDefinition.IsSystem == false
      ) {
        this.selectedReport.Parameters[i].SetBackgroundColorForSavedDefinition = true;
      }

      /* ***************************** CONVERT ANY SAVED DEFINITIONS  ******************************/

      // handle bit parameters if saved definition to convert from string
      if (this.selectedReport.Parameters[i].DataType == 'bit' && this.selectedReport.Parameters[i].ParameterReportDefinition.HasParameterValueDefined) {
        if (this.selectedReport.Parameters[i].ParameterReportDefinition.Value == '1' || this.selectedReport.Parameters[i].ParameterReportDefinition.Value == true) {
          this.selectedReport.Parameters[i].ParameterReportDefinition.Value = true;
          this.selectedReport.Parameters[i].Value = true;
        }
        else {
          this.selectedReport.Parameters[i].ParameterReportDefinition.Value = false;
          this.selectedReport.Parameters[i].Value = false;
        }

      }

      // handle datepicker value conversion here
      if ((this.selectedReport.Parameters[i].DataType == 'date' || this.selectedReport.Parameters[i].DataType == 'datetime') && this.selectedReport.Parameters[i].ParameterReportDefinition.HasParameterValueDefined) {
        const dateParts = this.selectedReport.Parameters[i].ParameterReportDefinition.Value.split('/');
        if (dateParts.length == 3) {
          // note: saved dates are in format "5/9/2018"
          const savedDate = new Date(dateParts[2], dateParts[0] - 1, dateParts[1]);
          this.selectedReport.Parameters[i].Value = savedDate;
        }

      }

      /* ***************************** END - CONVERT ANY SAVED DEFINITIONS  ******************************/

    }
  }

  getBackgroundColorForSavedDefinition(parameter: ReportParameter) {

    let backgroundColor: string;
    if (parameter.ParameterReportDefinition.IsDistrictDefinedParameter) {
      backgroundColor = this.reportService.backgroundColorForDistrictDefinedDefinition;
    }
    else if (parameter.ParameterReportDefinition.Login_ID > 0) {
      backgroundColor = this.reportService.backgroundColorForUserDefinedDefinition;
    }
    return backgroundColor;
  }



  setParameterRows(tableCellsPerRow: number) {


    // this.ChunkedParameters = this.chunkParameters(this.selectedReport.Parameters, tableCellsPerRow);

    this.ChunkedParameters = new ParameterRows();

    this.chunkParameters(this.selectedReport.Parameters, tableCellsPerRow);





  }

  handleDistributeByEmailOption(recipients: string) {

    // const recipients: string = value.Value;

    if (recipients.indexOf('1') !== -1) {
      this.distributeByEmailOption_StudentSelected = true; // student is checked (-1 is all and would include this)
    }
    else {
      this.distributeByEmailOption_StudentSelected = false;
    }

    if (recipients.indexOf('2') !== -1) {
      this.distributeByEmailOption_PrimaryContactSelected = true; // primary contact is checked
    }
    else {
      this.distributeByEmailOption_PrimaryContactSelected = false;
    }

    if (recipients.indexOf('3') !== -1) {
      this.distributeByEmailOption_AllElectronicContactsSelected = true; // all electronic contacts is checked
    }
    else {
      this.distributeByEmailOption_AllElectronicContactsSelected = false;
    }

  }



  chunkParameters(params: ReportParameter[], maxNumberOfColumns: number) {
    const nonPrivateParameters: ReportParameter[] = [];

    let newParamsRows: ReportParameter[][] = []; // new ReportParameter();
    const group_Ids: number[] = [];

    for (let p = 0; p < params.length; p++) {

      // handle bit parameters
      if (params[p].DataType == 'bit') {
        if (params[p].Value == '1') {
          params[p].Value = true;
        }
        else {
          params[p].Value = false;
        }
      }

      // if ((this.showHiddenParameters && !params[p].ParameterName.toLowerCase().startsWith('@p_')) || !params[p].ParameterReportDefinition.IsHidden) {
      if (
        (
          (
            this.userHasPrivilegeAddEditDistrictReportDefinitions || !params[p].ParameterReportDefinition.IsDistrictDefinedParameter
          )
          && this.showHiddenParameters && !params[p].IsSystemHiddenParameter // !params[p].ParameterName.startsWith('@p_')
        )
        || !params[p].ParameterReportDefinition.IsHidden) {

        // don't push group parameters yet if grouping is turned on, we will add them later

        // if (this.reportService.useParameterGroups) {
        //   if (!params[p].IsInGroup) {
        //     nonPrivateParameters.push(params[p]);
        //   }
        // }
        // else {
        // NOT using groups

        // if (params[p].Group_ID > 0 && !group_Ids.includes(params[p].Group_ID)) {
        //   group_Ids.push(params[p].Group_ID);
        // }

        // get a distinct list of group_Ids, including zero for non-grouped parameters
        if (!group_Ids.includes(params[p].Group_ID)) {
          group_Ids.push(params[p].Group_ID);
        }

        // // TODO: COMMENT OR REMOVE AFTER TESTING!!!
        // if (params[p].ParameterName == '@GradeLevelIdentifier' || params[p].ParameterName == '@CampusEnrollment') {
        //   params[p].ShowOptionsVertically = true;
        // }




        if (params[p].ParameterName.toLowerCase() == '@distributebyemailoption') {

          const recipients: string = params[p].Value;

          this.handleDistributeByEmailOption(recipients);
        }

        // ONE-4386 - HIDE DISTRIBUTE BY EMAIL PARAMETERS -- THIS WILL BE NEED TO BE REMOVED AFTER ONE-4387 HAS BEEN COMPLETED

        // THESE PARAMETERS ARE TO BE EXCLUDED FROM THE PARAMETERS SCREEN
        if ( // params[p].ParameterName.toLowerCase() == '@distributebyemailoption'
          // HIDE PARAMETERS BELOW (also need to hide them in spOneSISReporting_GetReportDefinitions)
          params[p].ParameterName.toLowerCase() == '@distributebyemailsubject'  // ONE-4387 I'm gonna still hide these optional parameters
          || params[p].ParameterName.toLowerCase() == '@distributebyemailbody'
          || params[p].ParameterName.toLowerCase() == '@distributebyemailfromaddress'

          || (!this.loginService.LoginSettings.UtilizeDistributebyEmail && params[p].ParameterName.toLowerCase() == '@distributebyemailoption')
          || params[p].ControlType == 'trctrl' // transcript tracking
          || (this.utilizeTranscriptTracking == false && (params[p].ParameterName == '@p_Post_HS_Contact_Type' || params[p].ParameterName == '@p_Post_HS_Institution' || params[p].ParameterName == '@p_Post_HS_Comments'))
          // || (!this.loginService.LoginSettings.UtilizeTranscriptTracking && params[p].ControlType == 'trctrl')
        ) {
          // DO NOT ADD PARAMETER, we want to exclude these for now
        }
        else {

          nonPrivateParameters.push(params[p]);
        }



        // }

        // nonPrivateParameters.push(System.convert<ReportParameter>(params[p], new ReportParameter()));
      }
    } // end going through ALL parameters

    // now break up into individual groups


    const groupParameters: ReportParameter[][] = [];

    const tempParmArray: ReportParameter[][] = [];

    for (let g = 0; g < group_Ids.length; g++) {
      let thisGroupParameters: ReportParameter[] = [];

      for (let p = 0; p < nonPrivateParameters.length; p++) {
        if (nonPrivateParameters[p].Group_ID == group_Ids[g]) {

          thisGroupParameters.push(nonPrivateParameters[p]);

        }
      } // END looping through group parameterrs

      thisGroupParameters = this.getGroup(thisGroupParameters);

      groupParameters.push(thisGroupParameters);
      const tempGroup: number[] = [];
      tempGroup.push(group_Ids[g]);

      const tempParameterRows: ParameterRows[] = [];

      tempParameterRows.push(this.getParameterRows(thisGroupParameters, maxNumberOfColumns, tempGroup));

      for (let r = 0; r < tempParameterRows.length; r++) {
        const myParamRows = tempParameterRows[r];
        for (let rw = 0; rw < myParamRows.Rows.length; rw++) {
          const myParamRow = myParamRows.Rows[rw];
          for (let p = 0; p < myParamRow.Parameters.length; p++) {

            // if (this.inDebugMode) {
            //   console.log(myParamRow.Parameters[p]);
            // }

            // newParamsRows.push(myParamRow.Parameters[p]);

            // newParamsRows.push
          }


          tempParmArray.push(myParamRow.Parameters);

        }

      }

    } // END looping through groups

    newParamsRows = tempParmArray; // ReportParamter[][]

    for (let pr = 0; pr < newParamsRows.length; pr++) {
      const newParamRow = new ParameterRow();
      const newGroupParamRow = new ParameterRow();
      newParamRow.Parameters = newParamsRows[pr];
      let thisGroupHasBeenHandled = false;

      // handle groups??
      for (let p = 0; p < newParamRow.Parameters.length; p++) {

        if (newParamRow.Parameters[p].Group_ID > 0) {

          // START ONE-2400 TESTING *************
          if (newParamRow.Parameters[p].ParameterReportDefinition.IsHidden) {
            continue;
          }
          // END ONE-2400 TESTING *************


          // BEGIN HANDLING GROUP

          if (newParamRow.Parameters[p].Group_ID) {

            newGroupParamRow.Group_ID = newParamRow.Parameters[p].Group_ID;

          }


          if (newParamRow.Parameters[p].IsStartOfVisibleGroup) {

            newGroupParamRow.IsStartOfVisibleGroup = newParamRow.Parameters[p].IsStartOfVisibleGroup;

          }

          if (newParamRow.Parameters[p].IncludeLineAtStartOfGroup) {

            newGroupParamRow.IncludeLineAtStartOfGroup = newParamRow.Parameters[p].IncludeLineAtStartOfGroup;

          }

          if (newParamRow.Parameters[p].IsStartOfVisibleGroup) {
            newGroupParamRow.IsStartOfVisibleGroup = newParamRow.Parameters[p].IsStartOfVisibleGroup;
          }

          if (newParamRow.Parameters[p].IncludeGroupLabel) {
            newGroupParamRow.IncludeGroupLabel = newParamRow.Parameters[p].IncludeGroupLabel;
          }

          if (newParamRow.Parameters[p].GroupLabel > '') {
            newGroupParamRow.GroupLabel = newParamRow.Parameters[p].GroupLabel;
          }

        }

        if (newGroupParamRow.Group_ID > 0 && thisGroupHasBeenHandled == false) {

          this.ChunkedParameters.Rows.push(newGroupParamRow);
          thisGroupHasBeenHandled = true;
        }


      }

      this.ChunkedParameters.Rows.push(newParamRow);

    }

    return newParamsRows;

  }

  getGroup(reportParametersInGroup: ReportParameter[]): ReportParameter[] {
    return (reportParametersInGroup);
  }


  getParameterRowParameters(paramRows: ParameterRow): ReportParameter[] {
    const paramRowParams: ReportParameter[] = [];

    for (let p = 0; p < paramRows.Parameters.length; p++) {

      const params: ReportParameter[] = [];
      paramRowParams.push(paramRows[p]);

    }

    return paramRowParams;
  }

  handleParameterGroups(paramsRows: ParameterRows) {
    // NOW WE START TO HANDLE GROUPS

    let needToAddNewParameterRow = false;

    for (let r = 0; r < paramsRows.Rows.length; r++) {

      needToAddNewParameterRow = false;
      const paramRow = new ParameterRow();
      paramRow.HasParameterInGroup = false;

      // now we need to handle parameter groups at the parameter row level

      const groupParamRow = new ParameterRow();

      for (let pr = 0; pr < paramRow.Parameters.length; pr++) {

        if (!paramRow.AlreadyCheckedForGroupStart) {

          if (!paramRow.Parameters[pr].IsInGroup) {
            continue;
          }

          // groupParamRow
          groupParamRow.HasParameterInGroup = true;

          if (paramRow.Parameters[pr].IsStartOfVisibleGroup) {
            groupParamRow.IsStartOfVisibleGroup = true;
            paramRow.HasParameterInGroup = true; // mark the 'regular' param row
            groupParamRow.AlreadyCheckedForGroupStart = true;
            groupParamRow.IncludeGroupLabel = paramRow.Parameters[pr].IncludeGroupLabel;
            if (groupParamRow.IncludeGroupLabel) {
              groupParamRow.GroupLabel = paramRow.Parameters[pr].GroupLabel;
            }
            groupParamRow.IncludeLineAtStartOfGroup = paramRow.Parameters[pr].IncludeLineAtStartOfGroup;

            break; // we only need to check one start parameter in the row

          } // END IsStartOfVisibleGroup

        } // END AlreadyCheckedForGroupStart

        if (!paramRow.AlreadyCheckedForGroupEnd) {

          if (!paramRow.Parameters[pr].IsInGroup) {
            continue;
          }

          groupParamRow.HasParameterInGroup = true;

          if (paramRow.Parameters[pr].IsEndOfVisibleGroup) {
            groupParamRow.IsEndOfVisibleGroup = true;
            groupParamRow.AlreadyCheckedForGroupEnd = true;

            groupParamRow.IncludeLineAtEndOfGroup = paramRow.Parameters[pr].IncludeLineAtEndOfGroup;

            break; // we only need to check one end parameter in the row

          }

        } // END IsEndOfVisibleGroup


        if (groupParamRow.IncludeLineAtStartOfGroup && groupParamRow.HasParameterInGroup && groupParamRow.Parameters.length == 0) {
          paramsRows.Rows.push(groupParamRow);
        }


      } // END looping through GROUP parameters



    }
    // END HANDLE GROUPS
  }

  getParameterRows(nonPrivateParameters: ReportParameter[], maxNumberOfColumns: number, group_Ids: number[]): ParameterRows {

    const newParamsRows = new ParameterRows();
    let group_Id = 0;

    const groupParameters: ReportParameter[] = [];
    // this gets run for each parameter group, group_Id will be zero if they are not in a Definitions.ReportGroup

    for (let g = 0; g < group_Ids.length; g++) {

      group_Id = group_Ids[g];
      // const C: ReportParameter[] = [];
      // groupParameters.length = 0;

      // first we need to grab only the parameters in the particular group
      for (let p = 0; p < nonPrivateParameters.length; p++) {

        if (nonPrivateParameters[p].Group_ID == group_Id) {
          groupParameters.push(nonPrivateParameters[p]);
        }
      }

      let paramRow = new ParameterRow();
      newParamsRows.Rows = [];
      paramRow.Parameters = [];
      let currentColumn = 1;

      for (let p = 0; p < groupParameters.length; p++) {

        groupParameters[p].ParameterHasBeenAddedToRow = false;
        if (groupParameters[p].IsStartOfVisibleGroup) {

          const startOfGroupParamRow = new ParameterRow();
          startOfGroupParamRow.IsStartOfVisibleGroup = true;
          startOfGroupParamRow.Group_ID = groupParameters[p].Group_ID;
          startOfGroupParamRow.GroupLabel = groupParameters[p].GroupLabel;
          startOfGroupParamRow.IncludeLineAtStartOfGroup = groupParameters[p].IncludeLineAtStartOfGroup;
          startOfGroupParamRow.IncludeGroupLabel = groupParameters[p].IncludeGroupLabel;
          startOfGroupParamRow.MaxNumberOfParameters = 0;
          newParamsRows.Rows.push(startOfGroupParamRow);
        }

        if (groupParameters[p].SpanEntireRow) {
          // we need to break out any parameters which span the entire row to a new row

          // first, we need to look for parameters which have NOT been added to a row
          // because they did not reach the max number of parameters

          const paramRowForParamsNotAddedYet = new ParameterRow();

          for (let x = 0; x < p; x++) {

            if (!groupParameters[x].ParameterHasBeenAddedToRow) {

              paramRowForParamsNotAddedYet.Parameters.push(groupParameters[x]);
            }
          }

          if (paramRowForParamsNotAddedYet.Parameters.length > 0) {

            this.setParameterHasBeenAddedToRow(paramRowForParamsNotAddedYet);


            newParamsRows.Rows.push(paramRowForParamsNotAddedYet);
          }

          paramRow = new ParameterRow();

          if (groupParameters[p].IsInGroup) {
            paramRow.HasParameterInGroup = true;
            paramRow.Group_ID = group_Id;
          }

          groupParameters[p].ParameterHasBeenAddedToRow = true;
          paramRow.Parameters.push(groupParameters[p]);
          paramRow.MaxNumberOfParameters = 1;
          newParamsRows.Rows.push(paramRow);

          if (groupParameters[p].IsEndOfVisibleGroup) {
            const endOfGroupParamRow = new ParameterRow();
            endOfGroupParamRow.IsEndOfVisibleGroup = true;
            endOfGroupParamRow.Group_ID = groupParameters[p].Group_ID;
            endOfGroupParamRow.GroupLabel = groupParameters[p].GroupLabel;
            endOfGroupParamRow.IncludeLineAtEndOfGroup = groupParameters[p].IncludeLineAtEndOfGroup;
            endOfGroupParamRow.IncludeGroupLabel = groupParameters[p].IncludeGroupLabel;
            endOfGroupParamRow.MaxNumberOfParameters = 0;
            newParamsRows.Rows.push(endOfGroupParamRow);
          }

          currentColumn = 1;
          paramRow = new ParameterRow();

          continue;
        }

        else { // DOES NOT SPAN WHOLE ROW

          if (currentColumn <= maxNumberOfColumns) {

            paramRow.Parameters.push(groupParameters[p]);
            paramRow.MaxNumberOfParameters = maxNumberOfColumns;

          }

          if (currentColumn == maxNumberOfColumns || p == groupParameters.length - 1) {
            // we've reached maxNumberOfColumns

            if (groupParameters[p].IsInGroup) {
              paramRow.HasParameterInGroup = true;
              paramRow.Group_ID = group_Id;

            }

            this.setParameterHasBeenAddedToRow(paramRow);

            newParamsRows.Rows.push(paramRow);

            if (groupParameters[p].IsEndOfVisibleGroup) {
              const endOfGroupParamRow = new ParameterRow();
              endOfGroupParamRow.IsEndOfVisibleGroup = true;
              endOfGroupParamRow.Group_ID = groupParameters[p].Group_ID;
              endOfGroupParamRow.GroupLabel = groupParameters[p].GroupLabel;
              endOfGroupParamRow.IncludeLineAtEndOfGroup = groupParameters[p].IncludeLineAtEndOfGroup;
              endOfGroupParamRow.IncludeGroupLabel = groupParameters[p].IncludeGroupLabel;
              endOfGroupParamRow.MaxNumberOfParameters = 0;
              newParamsRows.Rows.push(endOfGroupParamRow);
            }

            paramRow = new ParameterRow();
            if (groupParameters[p].IsInGroup) {
              paramRow.HasParameterInGroup = true;
              paramRow.Group_ID = group_Id;
            }

            currentColumn = 1;
            continue;
            // }

          }

          currentColumn++;

        }



        // } // end handling group

      } // END for (let p

    } // END handling ALL groups - for (let g



    this.handleParameterGroups(newParamsRows);

    return newParamsRows;
  }

  setParameterHasBeenAddedToRow(paramRow: ParameterRow) {
    for (let i = 0; i < paramRow.Parameters.length; i++) {
      paramRow.Parameters[i].ParameterHasBeenAddedToRow = true;
    }
  }

  showHiddenParametersChecked() {
    this.showHiddenParameters = !this.showHiddenParameters;
    if (this.showHiddenParameters) {
      this.hiddenParametersLabel = 'Hide Hidden Parameters';
    }
    else {
      this.hiddenParametersLabel = 'Show Hidden Parameters';
    }

    this.initParameters();
  }

  distributeByEmailClick() {

    this.reportService.isDistributebyEmail = true;
    this.selectedReport.IsDistributeByEmail = true;

    this.reportService.distributeByEmailOption_StudentSelected = this.distributeByEmailOption_StudentSelected;
    this.reportService.distributeByEmailOption_PrimaryContactSelected = this.distributeByEmailOption_PrimaryContactSelected;
    this.reportService.distributeByEmailOption_AllElectronicContactsSelected = this.distributeByEmailOption_AllElectronicContactsSelected;

    /*
    select 'Student' as TextField, 1 as ValueField
    union all
    select 'Primary Contact' as TextField, 2 as ValueField
    union all
    select 'All Electronic Contacts' as TextField, 3 as ValueField
    */

    // confirm they want to send the emails
    this.confirmReportToEmailDialogRef = this.confirmReportToEmailDialog.open(ConfirmReportToEmailComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true
    });

    this.confirmReportToEmailDialogRef.afterClosed().subscribe(result => {

      if (result == true) {
        this.executeDistributeByEmailAsync();
        this.thisDialogRef.close();  // close report parameters
      }
    });

    this.reportService.SelectedReport = this.selectedReport;

  }

  archiveReportClick() {

    this.reportService.SelectedReport = this.selectedReport;

    // open archive popup
    this.archiveReportModalDialogRef = this.archiveReportModalDialog.open(ArchiveReportModalComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true
    });

    this.archiveReportModalDialogRef.afterClosed().subscribe(result => {

      if (result == true) {
        this.thisDialogRef.close();
      }
    });

  }

  isEven(rownum: number) {
    return (rownum % 2) == 0;
  }

  reportOptionsClick() {
    this.reportService.SelectedReport = this.selectedReport;

    this.reportOptionsDialogRef = this.reportOptionsDialog.open(ReportOptionsComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true
    });

    this.reportOptionsDialogRef.afterClosed().subscribe(isDirty => {

      if (isDirty) {


        // do we really want to reload the report here?

        // clearing the parameters and definitions here so the DTO knows it is another initial load
        this.selectedReport.Parameters.length = 0;
        this.selectedReport.ReportDefinitions.length = 0;

        this.reportService.getReportParameters(-1, this.selectedReport, false).subscribe(selectedReport => {

          this.reportService.SelectedReport = selectedReport;

          this.ngOnInit();

        });

      } // end if (isDirty)

    });


  }



  radioButtonChange(event: MatRadioChange, param: ReportParameter) {
    if (param.ParameterReportDefinition.CanSave) {
      param.ParameterReportDefinition.Value = event.value;
    }
  }


  datePickerChanged(param: ReportParameter) {

    if (param.ParameterReportDefinition.CanSave) {
      param.ParameterReportDefinition.Value = param.Value;
    }

  }


  SelectedReportToConsole() {
    console.log(this.ChunkedParameters);
    console.log(this.selectedReport);

  }

  sendToEmailChecked(isChecked: boolean) {

    // right now the only errors being handled are for report to email
    // so clear them out if they uncheck the checkbox
    if (!isChecked) {
      this.errors = [];
    }
  }


  // ERROR CHECKING

  // START - Implementing for HasErrors **********************

  save() {

  }

  checkErrors(): number {
    this.errors = [];
    this.validateFields();
    return this.errors.length;

  }

  validateFields() {
    this.errors = [];

    if (this.selectedReport.SendToEmail) {
      this.validateEmailFields();

    }

  }

  // END - Implementing for HasErrors **********************


  validateEmailFields() {
    const emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
    const emailsTo: string[] = this.selectedReport.EmailsToSendReport.replace(' ', '').split(';');

    // remove final empty string from split
    if (emailsTo.length > 1) {
      if (emailsTo[emailsTo.length - 1] == '') {
        emailsTo.length = emailsTo.length - 1;
      }
    }

    /* ******************** START EMAIL FROM VALIDATION  *********************/

    // Email From required -- FIRST MESSAGE
    if (this.selectedReport.EmailFrom.trim().length == 0) {

      this.errors.push({
        fieldName: 'Email From',
        errorMsg: 'Required field.',
        fieldRef: this.emailFrom
      });

    }
    else {

      // check Email From format -- SECOND MESSAGE
      if (this.selectedReport.EmailFrom.trim().match(emailFormat) == null) {
        this.errors.push({
          fieldName: 'Email From',
          errorMsg: 'Invalid email address.',
          fieldRef: this.emailFrom
        });

      }

      else {

        // check Email From is a single email -- THIRD MESSAGE
        if (this.selectedReport.EmailFrom.split(';').length > 1) {

          this.errors.push({
            fieldName: 'Email From',
            errorMsg: 'Must be a single email.',
            fieldRef: this.emailFrom
          });

        }
      }

    }

    /* ******************** START EMAIL TO VALIDATION  *********************/

    // Send to Email required -- FIRST MESSAGE
    if (this.selectedReport.EmailsToSendReport.trim().length == 0) {

      this.errors.push({
        fieldName: 'Send to Email(s)',
        errorMsg: 'Required field.',
        fieldRef: this.emailsToSendReport
      });

    }
    else {

      // check Send to Email(s) format -- SECOND MESSAGE
      for (let i = 0; i < emailsTo.length; i++) {
        if (emailsTo[i].length > 0 && emailsTo[i].trim().match(emailFormat) == null) {

          this.errors.push({
            fieldName: 'Send to Email(s)',
            errorMsg: emailsTo[i].trim() + ' is not a valid email format',
            fieldRef: this.emailsToSendReport
          });

        }
      }


    }


    /* ******************** START EMAIL SUBJECT VALIDATION  *********************/

    // Email Subject required
    if (this.selectedReport.EmailSubject.trim().length == 0) {

      this.errors.push({
        fieldName: 'Email Subject',
        errorMsg: 'Required field.',
        fieldRef: this.emailSubject
      });
    }

  }


  runReportToEmail(reportType: string) {
    const errCount = this.checkErrors();

    if (errCount > 0) {
      // drop out here
      return;
    }


    // confirm they want to send the emails
    this.confirmReportToEmailDialogRef = this.confirmReportToEmailDialog.open(ConfirmReportToEmailComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true
    });

    this.confirmReportToEmailDialogRef.afterClosed().subscribe(result => {

      if (result == true) {
        this.executeRunReportToEmailAsync();
        this.thisDialogRef.close();
      }
    });


  }



  //   this will kick off a background process by unsubscribing immediately
  executeRunReportToEmailAsync() {
    const asyncSub = this.reportService.runReportToEmail().subscribe(() => { });
    setTimeout(() => {
      asyncSub.unsubscribe();
    }, 0);
  }

  //   this will kick off a background process by unsubscribing immediately
  executeDistributeByEmailAsync() {
    const asyncSub = this.reportService.distributeByEmail().subscribe(() => { });
    setTimeout(() => {
      asyncSub.unsubscribe();
    }, 0);
  }


  getReportParameters(paramId: number) {
    this.reportService.getReportParameters(paramId, this.selectedReport).subscribe(report => {

      this.selectedReport = report; //  update the local reference

      // IMPORTANT: we need to update the chunked rows to refresh the references to the updated parameters

      this.initParameters();

    });

  }



  cancelSendToEmailClick() {

    this.selectedReport.SendToEmail = !this.selectedReport.SendToEmail;
    this.showCancelSendToEmail = !this.showCancelSendToEmail;

  }

  cancelShowReportOptionsClick() {

    this.selectedReport.ShowReportOptions = !this.selectedReport.ShowReportOptions;
    this.showCancelShowReportOptions = !this.showCancelShowReportOptions;

  }


  cancelShowReportParameters() {
    // this.cancelShowReport = true;

    // if auto-run then use close dialog on that component for unsaved changes
    if (this.selectedReport.AutoRunReport && this.reportService.isForSchedule) {
      this.AutoRunComponent.cancelClick();
    } else {
      this.thisDialogRef.close();
    }
  }


  // gets the email regex for validation
  getEmailRegexp() {
    return this.reportService.getEmailRegexp();
  }

  getColumnWidth(parameter: ReportParameter) {
    if (parameter.SpanEntireRow) {
      return '100%';
    }
    else {
      return this.ParamColWidth;
    }
  }

  getFlexDirection(parameter: ReportParameter) {
    if (parameter.ShowOptionsVertically) {
      return 'column';
    }
    else {
      return 'row';
    }
  }

  getArrangeDirection(parameter: ReportParameter) {
    if (parameter.ShowOptionsVertically) {
      return 'vertical';
    }
    else {
      return 'horizontal';
    }
  }

  getWrap(parameter: ReportParameter) {
    if (parameter.NoWrap) {
      return 'nowrap';
    }
    else {
      return 'wrap';
    }
  }


  ddlChange(parameter: ReportParameter) {

    this.parameterChanged(parameter);

  }

  ddbcblChanged(parameter: ReportParameter, dataItem: DataSource) {
    dataItem.IsSelected = !dataItem.IsSelected;

    let allIndex = -1;

    for (let x = 0; x < parameter.DataSource.length; x++) {
      if (parameter.DataSource[x].TextField.toString().toLowerCase() == 'all' && parameter.DataSource[x].ValueField == '-1') {
        allIndex = x;
      }
    }

    if (allIndex > -1) { // has ALL checkbox


      //  check/uncheck when All is changed
      if (dataItem.TextField.toString().toLowerCase() == 'all' && dataItem.ValueField == '-1') { //  -1 is All

        //  now set the others to match All
        for (let i = 0; i < parameter.DataSource.length; i++) {
          parameter.DataSource[i].IsSelected = parameter.DataSource[allIndex].IsSelected;
        }

      }

      //  uncheck the All checkbox if ANY checkbox is unselected

      for (let i = 0; i < parameter.DataSource.length; i++) {

        if (i != allIndex && !parameter.DataSource[i].IsSelected) {
          parameter.DataSource[allIndex].IsSelected = false; //  uncheck All
          break;
        }
      }


      //  we need to check the ALL checkbox if ALL other checkboxes are checked

      let allCheckBoxesAreChecked = true;

      for (let i = 0; i < parameter.DataSource.length; i++) {
        if (i != allIndex && !parameter.DataSource[i].IsSelected) {
          allCheckBoxesAreChecked = false;
          break;
        }
      }
      if (allCheckBoxesAreChecked) {
        parameter.DataSource[allIndex].IsSelected = true;
      }



    }



    //  we need to update the MultiValue based on the selected checkboxes

    const newMulivalues: string[] = []; //  must initialize for push to work!

    //     parameter.MultiValue.
    for (let i = 0; i < parameter.DataSource.length; i++) {
      if (parameter.DataSource[i].IsSelected) {
        newMulivalues.push(parameter.DataSource[i].ValueField);
      }
    }

    parameter.MultiValue = newMulivalues;


    this.parameterChanged(parameter);
  }

    autoRunSaveClick() {
      this.AutoRunComponent.saveClick();
    }


  parameterChanged(parameter: ReportParameter, event?: any, index?: number) {

    //  for cbl we need to reset the parameter's value to match the DataSource.IsSelected is true

    if (parameter.ControlType == 'cbl') {
      this.handleAllChecked(parameter, index);
      parameter.Value = '';
      for (let i = 0; i < parameter.DataSource.length; i++) {
        if (parameter.DataSource[i].IsSelected) {
          parameter.Value += parameter.DataSource[i].ValueField + ',';
        }

        // parameter.Value = parameter.Value.replace(/(^,)|(,$)/g, '');
      }

      if (parameter.Value.endsWith(',')) {
        //  now remove trailing comma
        parameter.Value = parameter.Value.slice(0, -1);
      }

    }


    //  for ddcbl we need to reset the parameter's value to match the MultiValue property

    if (parameter.ControlType == 'ddcbl') {

      parameter.Value = '';

      for (let i = 0; i < parameter.MultiValue.length; i++) {
        parameter.Value += parameter.MultiValue[i] + ',';
      }

      parameter.Value = parameter.Value.replace(/(^,)|(,$)/g, '');
    }

    if (parameter.IsParent) {

      this.getReportParameters(parameter.RC_ID);

    }

    if (parameter.ParameterName.toLowerCase() == '@distributebyemailoption') {


      const recipients: string = parameter.Value;

      this.handleDistributeByEmailOption(recipients);

    }
  }

  handleAllChecked(parameter: ReportParameter, index: number) {
    //  check/uncheck when All is changed
    if (index == 0 && parameter.DataSource[0].TextField.toString().toLowerCase() == 'all' && parameter.DataSource[0].ValueField == '-1') { //  -1 is All

      //  now set the others to match All
      for (let i = 0; i < parameter.DataSource.length; i++) {
        parameter.DataSource[i].IsSelected = parameter.DataSource[0].IsSelected;
      }
      return; // drop out here
    }

    // otherwise, we need to set the All checkbox based on selections

    let firstCheckBoxIsAll = false;

    if (parameter.DataSource[0].TextField.toString().toLowerCase() == 'all' && parameter.DataSource[0].ValueField == '-1') {
      firstCheckBoxIsAll = true;
    }

    //  uncheck the All checkbox if ANY checkbox is unselected
    if (firstCheckBoxIsAll) {
      for (let i = 1; i < parameter.DataSource.length; i++) { //  starting at index 1 instead of o to skip looking at All

        if (!parameter.DataSource[i].IsSelected) {
          parameter.DataSource[0].IsSelected = false; //  uncheck All
          break;
        }
      }
    }

    //  we need to check the ALL checkbox if ALL other checkboxes are checked

    let allCheckBoxesAreChecked = true;

    if (firstCheckBoxIsAll) {
      for (let i = 1; i < parameter.DataSource.length; i++) {
        if (!parameter.DataSource[i].IsSelected) {
          allCheckBoxesAreChecked = false;
          break;
        }
      }
      if (allCheckBoxesAreChecked) {
        parameter.DataSource[0].IsSelected = true;
      }
    }


    this.selectedReport.Parameters[parameter.Id].ParameterReportDefinition.Value = parameter.Value;


  }

  textChanged(parameter: ReportParameter) {

  }


  runReport(reportType: string) {

    this.selectedReport.ReportFormat = reportType;
    this.reportService.SelectedReport = this.selectedReport; //  ???

    this.reportService.runReport().subscribe(results => {

      if (reportType == 'PDF' || reportType == 'EXCEL') {
        this.runReportByType(reportType, results);
      }

    });

  }


  runReportByType(reportType: string, results): void {

    try {

      this.selectedReport.ReportFormat = reportType; // 'PDF';

      const byteCharacters: string = atob(results);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray: Uint8Array = new Uint8Array(byteNumbers);


      let fileExtension: string;
      let mimeType: string;
      if (this.selectedReport.ReportFormat == 'PDF') {
        mimeType = 'application/pdf';
        fileExtension = '.pdf';
      } else if (reportType == 'EXCEL') {
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-utf-8;';
        fileExtension = '.xls';
      }

      let FileAsBlob: Blob;

      if (reportType == 'PDF') {
        FileAsBlob = new Blob([byteArray], { type: 'application/pdf' });
      }
      else if (reportType == 'EXCEL') {
        FileAsBlob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + results });
      }

      //  For other browsers:
      //  Create a link pointing to the ObjectURL containing the blob.

      const reportNameWithoutSpaces: string = this.selectedReport.Name.replace(/ /g, '');

      const data = window.URL.createObjectURL(FileAsBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = reportNameWithoutSpaces + fileExtension;

      link.click();

      //  For Firefox it is necessary to delay revoking the ObjectURL
      setTimeout(this.revokeObjectURL(data), 100);

    } catch { }

  } //  end runReportPDF

  //  For Firefox it is necessary to delay revoking the ObjectURL
  revokeObjectURL(data): any {
    window.URL.revokeObjectURL(data);
  }


  rblChanged(parameter: ReportParameter, dataItem: DataSource) {

    const selectedValueField = dataItem.ValueField;

    this.selectedReport.Parameters[parameter.Id].Value = selectedValueField;

    if (parameter.IsParent) {

      this.getReportParameters(parameter.RC_ID);
    }

    this.selectedReport.Parameters[parameter.Id] = parameter;

    this.reportService.SelectedReport.Parameters[parameter.Id] = parameter;

  } //  END rblChanged



  cblChanged(parameter: ReportParameter, dataItem: DataSource) {

    //  first toggle the checkbox

    dataItem.IsSelected = !dataItem.IsSelected;


    //  check/uncheck when All is changed
    if (dataItem.TextField.toString().toLowerCase() == 'all' && dataItem.ValueField == '-1') { //  -1 is All

      //  now set the others to match All
      for (let i = 0; i < parameter.DataSource.length; i++) {
        parameter.DataSource[i].IsSelected = parameter.DataSource[0].IsSelected;
      }
    }

    let firstCheckBoxIsAll = false;

    if (parameter.DataSource[0].TextField.toString().toLowerCase() == 'all' && parameter.DataSource[0].ValueField == '-1') {
      firstCheckBoxIsAll = true;
    }

    //  uncheck the All checkbox if ANY checkbox is unselected
    if (firstCheckBoxIsAll) {
      for (let i = 1; i < parameter.DataSource.length; i++) { //  starting at index 1 instead of o to skip looking at All

        if (!parameter.DataSource[i].IsSelected) {
          parameter.DataSource[0].IsSelected = false; //  uncheck All
          break;
        }
      }
    }

    //  we need to check the ALL checkbox if ALL other checkboxes are checked

    let allCheckBoxesAreChecked = true;

    if (firstCheckBoxIsAll) {
      for (let i = 1; i < parameter.DataSource.length; i++) {
        if (!parameter.DataSource[i].IsSelected) {
          allCheckBoxesAreChecked = false;
          break;
        }
      }
      if (allCheckBoxesAreChecked) {
        parameter.DataSource[0].IsSelected = true;
      }
    }


    //  now we need to reset the value of this parameter to include only selected items

    let newValue = '';

    for (let i = 0; i < parameter.DataSource.length; i++) {
      if (parameter.DataSource[i].IsSelected) {

        //  we need set the comma delimited value

        newValue += parameter.DataSource[i].ValueField + ',';

      }

    } //  END for loop

    if (newValue.toString().endsWith(',')) {
      //  now remove trailing comma
      newValue = newValue.toString().slice(0, -1);
    }

    parameter.Value = newValue; //  ??


    //  to update any dependencies

    if (parameter.IsParent) {

      this.getReportParameters(parameter.RC_ID);
    }

    this.parameterChanged(parameter); // ?????


    this.selectedReport.Parameters[parameter.Id] = parameter;

  } //  END cblChanged

  legendClick() {
    this.reportLegendDialogRef = this.reportLegendDialog.open(ReportLegendComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true
    });

  }

  studentSearchClick(parameter: ReportParameter) {
    this.StudentSearchDialogRef = this.studentSearchDialog.open(
      StudentSearchComponent,
      {
        data: {
          searchAndSelect: true,
          returnSelectedStudents: true

        },
        disableClose: true,
        width: '100%',
        height: '100%',
        maxHeight: '100vh',
        maxWidth: '100vw'
      });
    this.subscriptions.push(
      this.StudentSearchDialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {
          this.selectedStudentSearch = result;

          this.studentList = [];

          for (const key of Object.keys(this.selectedStudentSearch)) {

            this.studentList.push(this.selectedStudentSearch[key].StudentNumber);

            // remove commas, replace with carriage return
            this.studentListString = this.studentList.join('\r\n');
          }

          parameter.Value = this.studentListString; // set the parameters value

          this.selectedStudentSearch = undefined; // cleanup
          this.studentList = undefined; // cleanup

        }
      })
    );
  } // end studentSearchClick

  getQueryString() {
    // FOR DEBUGGING PURPOSES
    this.reportService.getReportQueueQuery(this.selectedReport).subscribe(queryString => {

      this.debugMessage = queryString; // this.debugMessage + queryString + '\r\n\r\n';

    });
  }

  isDebugModeInProductionChecked(checked: boolean) {
    this.isDebugModeInProduction = checked;
    this.reportService.isDebugModeInProduction = this.isDebugModeInProduction;
    if (this.inDebugMode || (this.reportService.isTylerAdmin && this.isDebugModeInProduction)) {
      this.showReportToConsole = true;
    }
    else {
      this.showReportToConsole = false;
    }
  }

    continuedWithoutSave(): any {
    }

    getBooleanValue(val: string): boolean {
      let isChecked = false;
      if(val.toLocaleLowerCase() == 'true')  {
        isChecked = true;
      }
      return isChecked;
    }



} //  END class ReportParametersComponent


